import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import {
  observabilityApiRef,
  ObservabilityClient,
} from './api/ObservabilityApi';
import { rcaAgentApiRef, RCAAgentClient } from './api/RCAAgentApi';
import { finopsAgentApiRef, FinOpsAgentClient } from './api/FinOpsAgentApi';

export const openchoreoObservabilityPlugin = createPlugin({
  id: 'openchoreo-observability',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: observabilityApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new ObservabilityClient({ discoveryApi, fetchApi }),
    }),
    createApiFactory({
      api: rcaAgentApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new RCAAgentClient({ discoveryApi, fetchApi }),
    }),
    createApiFactory({
      api: finopsAgentApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new FinOpsAgentClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const ObservabilityMetrics = openchoreoObservabilityPlugin.provide(
  createRoutableExtension({
    name: 'ObservabilityMetrics',
    component: () =>
      import('./components/Metrics/ObservabilityMetricsPage').then(
        m => m.ObservabilityMetricsPage,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const ObservabilityTraces = openchoreoObservabilityPlugin.provide(
  createRoutableExtension({
    name: 'ObservabilityTraces',
    component: () =>
      import('./components/Traces/ObservabilityTracesPage').then(
        m => m.ObservabilityTracesPage,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const ObservabilityRCA = openchoreoObservabilityPlugin.provide(
  createRoutableExtension({
    name: 'ObservabilityRCA',
    component: () => import('./components/RCA/RCAPage').then(m => m.RCAPage),
    mountPoint: rootRouteRef,
  }),
);

export const ObservabilityRuntimeLogs = openchoreoObservabilityPlugin.provide(
  createRoutableExtension({
    name: 'ObservabilityRuntimeLogs',
    component: () =>
      import('./components/RuntimeLogs/ObservabilityRuntimeLogsPage').then(
        m => m.ObservabilityRuntimeLogsPage,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const ObservabilityRuntimeEvents = openchoreoObservabilityPlugin.provide(
  createRoutableExtension({
    name: 'ObservabilityRuntimeEvents',
    component: () =>
      import('./components/RuntimeEvents/ObservabilityRuntimeEventsPage').then(
        m => m.ObservabilityRuntimeEventsPage,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const ObservabilityProjectRuntimeLogs =
  openchoreoObservabilityPlugin.provide(
    createRoutableExtension({
      name: 'ObservabilityProjectRuntimeLogs',
      component: () =>
        import(
          './components/RuntimeLogs/ObservabilityProjectRuntimeLogsPage'
        ).then(m => m.ObservabilityProjectRuntimeLogsPage),
      mountPoint: rootRouteRef,
    }),
  );

export const ObservabilityAlerts = openchoreoObservabilityPlugin.provide(
  createRoutableExtension({
    name: 'ObservabilityAlerts',
    component: () =>
      import('./components/Alerts/ObservabilityAlertsPage').then(
        m => m.ObservabilityAlertsPage,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const ObservabilityWirelogs = openchoreoObservabilityPlugin.provide(
  createRoutableExtension({
    name: 'ObservabilityWirelogs',
    component: () =>
      import('./components/Wirelogs/ObservabilityWirelogsPage').then(
        m => m.ObservabilityWirelogsPage,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const ObservabilityProjectIncidents =
  openchoreoObservabilityPlugin.provide(
    createRoutableExtension({
      name: 'ObservabilityProjectIncidents',
      component: () =>
        import('./components/Incidents/ObservabilityProjectIncidentsPage').then(
          m => m.ObservabilityProjectIncidentsPage,
        ),
      mountPoint: rootRouteRef,
    }),
  );

export const ObservabilityCostAnalysis = openchoreoObservabilityPlugin.provide(
  createRoutableExtension({
    name: 'ObservabilityCostAnalysis',
    component: () =>
      import('./components/CostAnalysis').then(m => m.CostAnalysisPage),
    mountPoint: rootRouteRef,
  }),
);
